export default __webpack_public_path__ + "static/media/rides.aee5f593.jpg";